module.exports = __webpack_public_path__ + "img/mvpIcon.160ce074.svg";